import { render, staticRenderFns } from "./TotalAvaliacoes.vue?vue&type=template&id=b34962be&scoped=true&"
import script from "./TotalAvaliacoes.vue?vue&type=script&lang=js&"
export * from "./TotalAvaliacoes.vue?vue&type=script&lang=js&"
import style0 from "./TotalAvaliacoes.vue?vue&type=style&index=0&id=b34962be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34962be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
